import Label from "components/form/Label";
import Button from "components/form/Button";
import Input from "components/form/Input";
import React, { useState, useEffect } from "react";
import { useAuth } from "hooks/auth";
import Loader from "components/ui/Loader";
import classNames from "classnames"
import {ErrorMessageAuth} from "components/form/ErrorMessage";
import {
    useSearchParams
} from 'react-router-dom';
import Layout from 'components/layout/Layout';
import AuthSessionStatus from 'components/auth/AuthSessionStatus'

const ResetPassword = () => {

    const { resetPassword } = useAuth({ middleware: 'guest' })

    const [email, setEmail] = useState(''),
        [password, setPassword] = useState(''),
        [token, setToken] = useState(''),
        [password_confirmation, setPasswordConfirmation] = useState(''),
        [errors, setErrors] = useState([]),
        [isLoading, setIsLoading] = useState(null),
        [isReady, setIsReady] = useState(false),
        [status, setStatus] = useState(null),
        [errorPwd, setErrorsPwd] = useState(null),
        [showPwd, setShowPwd] = useState(false);

    const submitForm = event => {
        event.preventDefault()

        resetPassword({
            email,
            password,
            token,
            password_confirmation,
            setErrors,
            setStatus,
            setIsLoading
        })
    }

    const [queryParameters] = useSearchParams();

    useEffect(() => {

        setEmail(queryParameters.get("email") || '')
        setToken(queryParameters.get("token") || '')

    }, [queryParameters])


    // Password
    useEffect(() => {
        if (password !== password_confirmation) {
            setErrorsPwd("New passwords are not identical");
            setIsReady(false);
        } else if (password.length < 8 || password_confirmation.length < 8) {
            setErrorsPwd("The password must be at least 8 characters long");
            setIsReady(false);
        } else {
            setErrorsPwd("");
            setIsReady(true);
        }

    }, [password, password_confirmation]);

    return (
        <Layout>
            <section className="flex flex-col md:flex-row h-auto pt-16 items-center bg-gray-50" >

                <div className="mt-0 sm:mt-2 xl:mt-2 pt-8 pb-8 mb-16 shadow-xl bg-white w-full h-2/3 sm:max-w-sm md:max-w-md lg:max-w-full md:mx-auto md:mx-0 px-6 md:w-1/2 lg:px-16 flex items-center justify-center">

                    <div className="w-full">

                        <h1 className="text-xl md:text-2xl text-gray-500 font-bold leading-tight mt-1"> Set up a new password </h1>

                        <ErrorMessageAuth errors={errors} />
                        <AuthSessionStatus className="mt-4" status={status} />

                        <form className="mt-6" autoComplete="off" onSubmit={submitForm}>
                            <div className='mt-4'>
                                <Label className="block text-gray-700">Email address </Label>
                                <Input
                                    type="email"
                                    className="w-full px-4 py-3 bg-white text-gray-500 mt-2 border-gray-300 
                                    focus:border-blue-500 focus:bg-white focus:outline-none"
                                    readOnly
                                    value={email}
                                />
                            </div>

                            <div className='mt-4'>
                                <Label className="block text-gray-700">New password </Label>
                                <Input
                                    type={showPwd ? 'text' : 'password'}
                                    className="w-full px-4 py-3 bg-white  text-gray-500 mt-2 border-gray-300 
                                    focus:border-blue-500 focus:bg-white focus:outline-none"
                                    autoFocus
                                    autoComplete="off"
                                    required
                                    value={password}
                                    onChange={event =>
                                        setPassword(event.target.value)
                                    }
                                />
                            </div>

                            <div className='mt-4'>
                                <Label className="block text-gray-700"> Confirm the new password  </Label>
                                <Input
                                    type={showPwd ? 'text' : 'password'}
                                    className="w-full px-4 py-3 bg-white text-gray-500 mt-2 border-gray-300 
                                    focus:border-blue-500 focus:bg-white focus:outline-none"
                                    autoComplete="off"
                                    required
                                    value={password_confirmation}
                                    onChange={event =>
                                        setPasswordConfirmation(event.target.value)
                                    }
                                />
                            </div>

                            <div className="flex items-center pl-0 py-4 text-sm md:font-sans text-xs text-gray-800">
                                <input
                                    id="checked-checkbox"
                                    type="checkbox"
                                    value=""
                                    onClick={() => setShowPwd(!showPwd)}
                                    className="w-4 h-4 text-yellow-400 bg-gray-100 rounded border-gray-300 focus:ring-yellow-400"
                                />
                                <span className="ml-1 inline">{showPwd ? 'Hide password' : 'Show password'}</span>
                            </div>

                            {errorPwd &&
                                <div className="flex flex-row justify-between px-4 py-4 bg-red-50 text-left sm:px-6 shadow-sm">
                                    <div className="list-none text-xs text-red-500">
                                        <span>{errorPwd}</span>
                                    </div>
                                    <div className="list-none text-xs text-red-500">
                                        <button onClick={() => setErrorsPwd('')} >x</button>
                                    </div>
                                </div>
                            }

                            <Button
                                disabled={!isReady}
                                type="submit"
                                className={classNames(
                                    !isLoading ? '' : 'bg-gray-400 opacity-50 cursor-wait',
                                    isReady ? '' : 'bg-gray-400 opacity-50 cursor-not-allowed',
                                    "w-full block w-full py-3 px-10 border border-pblue text-white text-md font-medium mt-3"
                                )}
                            >
                                {!isLoading ? 'Change' :
                                    <> <Loader /> Loading... </>
                                }
                            </Button>
                            <p className="mt-8 text-center"> <a href="/" className="text-blue-500 hover:text-pblue font-medium">Go to home</a></p>
                        </form>
                    </div>
                </div>
            </section>
        </Layout>

    )
}

export default ResetPassword
